import isNil from 'lodash/isNil';

// The income confirmation checkbox is always shown (FES-548). The backend requires
// incomeConfirmation for section completion when the program auto-rolls over income
// and assets, OR when the require-income-asset-confirmation flag makes the confirmation
// required on every program (FES-559). Save is hard-gated on the confirmation in those
// cases; otherwise the checkbox is optional and the section completes on checklist
// presence.
export const requiresIncomeConfirmation = (
  autoRolloverIncomeAndAssets: boolean,
  requireIncomeAssetConfirmation: boolean,
): boolean =>
  Boolean(autoRolloverIncomeAndAssets) ||
  Boolean(requireIncomeAssetConfirmation);

// When the confirmation is required the resident must confirm, so the form starts
// unreviewed. Otherwise the checkbox is optional, so it starts reviewed (pre-checked)
// and does not block Save. This mirrors getInitialAssetFormReviewed in the asset form.
export const getInitialIncomeFormReviewed = ({
  autoRolloverIncomeAndAssets,
  requireIncomeAssetConfirmation,
  incomeConfirmation,
  wasFormEdited,
}: {
  autoRolloverIncomeAndAssets: boolean,
  requireIncomeAssetConfirmation: boolean,
  incomeConfirmation: ?boolean,
  wasFormEdited: boolean,
}): boolean => {
  if (
    !requiresIncomeConfirmation(
      autoRolloverIncomeAndAssets,
      requireIncomeAssetConfirmation,
    )
  ) {
    return true;
  }
  if (isNil(incomeConfirmation) || wasFormEdited) {
    return false;
  }
  return incomeConfirmation;
};

// With income-for-minors on, minors report income on their own forms, so the adult's
// "unearned income of household members 17 and under" row is hidden. A "yes" saved
// before the flag was on still counts toward Total Annual Income and the TIC, so the
// row stays visible until someone answers "no".
export const isUnearnedMinorIncomeRowHidden = ({
  incomeForMinors,
  unearnedIncome17AndUnder,
}: {
  incomeForMinors: ?boolean,
  unearnedIncome17AndUnder: ?string,
}): boolean => Boolean(incomeForMinors) && unearnedIncome17AndUnder !== 'yes';
